import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'
import addParamsToQuery from '@/utils/addParamsToQuery'

const getItems = ({ commit }, params = {}) => {
  commit(types.TOGGLE_LOADING)
  let page = 'e_x_c_m_daily_plan_items'
  if (Object.entries(params).length > 0) {
    page = addParamsToQuery(page, params)
  }
  fetch(page)
    .then(response => response.json())
    .then((data) => {
      commit(types.TOGGLE_LOADING)
      commit(types.SET_ITEMS, data['hydra:member'])
      commit(types.SET_VIEW, data['hydra:view'])
    })
    .catch((e) => {
      commit(types.TOGGLE_LOADING)
      Vue.prototype.$Swal({
        type: 'error',
        title: Vue.prototype.$lang.t('notifications.store.errorTitle'),
        text: e.message,
        showConfirmButton: true,
        timer: 6000
      })
      console.log(e.message)
      // commit(types.SET_ERROR, e.message)
    })
}

export default getItems
